import Vue from 'vue'
import Vuex from 'vuex'
import loading from './moudels/loading'
import home from './moudels/home'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { // 子模块
    loading, home
  },
  mutations: {
    resetVuex(state, payload) {
      for (let key in payload) {
        state[key] = payload[key];
      }
    }
  }
})
